import { IReportResultModel } from "./model/IReportResultModel";
import { Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class ReportResultService extends ServiceBase {

    public async getReportResults(
        organizationId?: string, year?: number,
    ): Promise<Result<IReportResultModel>> {
        let url = "/Organization/" + organizationId + "/Reports/Result?";
        //let url = "https://localhost:7024/Firm/" + organizationId + "/Reports/Result?";

        if (year)
            url = url + "year=" + year;

        var result = await this.requestJson<IReportResultModel>({
            url: url,
            method: "GET"
        });
        return result;
    }
}